// extracted by mini-css-extract-plugin
export default {"container":"F1-z","heading":"G1-z","links":"H1-z","copy":"I1-z","subCopy":"J1-z","linksLeft":"K1-z","linksCenter":"L1-z","linksRight":"M1-z","link":"N1-z","onlyLink":"O1-z"};